import { isNative } from "@stepapp/core";
import { Block, HeaderLeft, palette, spacing } from "@stepapp/ui";
import { usePathname, useRouter } from "expo-router";
import React, { useCallback, useEffect, useState } from "react";
import { StyleSheet } from "react-native";
import { useCanGoBack } from "../../hooks";
import CityPickerSheet from "../Modal/CityPickerSheet";
import ShareCouponSheet from "../Modal/ShareCouponSheet";
import HeaderContent from "./HeaderContent";
import IntercomButton from "./IntercomButton";
import { useLocalizationCheck } from "./useLocalizationCheck";
import { useNavigationItems } from "./useNavigationItems";

const STICKY_TOP_SPACING = 6;

const HomeHeader = () => {
  const pathname = usePathname();
  const { back, replace } = useRouter();
  const canGoBack = useCanGoBack();
  const [isAttached, setIsAttached] = useState(false);

  const { modalVisible, setModalVisible } = useLocalizationCheck();
  const { navigationItems, shareCouponVisible, setShareCouponVisible } = useNavigationItems();

  const handleBackPress = useCallback(() => {
    if (!canGoBack) {
      replace("/");
      return;
    }
    back();
  }, [back, canGoBack, replace]);

  useEffect(() => {
    if (isNative) return () => {};

    const handleScroll = () => {
      if (window.scrollY > STICKY_TOP_SPACING) {
        if (!isAttached) {
          setIsAttached(true);
        }
      } else if (isAttached) {
        setIsAttached(false);
      }
    };

    document.addEventListener("scroll", handleScroll);

    return () => document.removeEventListener("scroll", handleScroll);
  }, [isAttached]);

  const loginNativeNavigation = pathname.includes("/login") && isNative;

  return (
    <Block style={styles.container}>
      {loginNativeNavigation ? (
        <Block justifySpace row paddingLeft={2.5} style={styles.content}>
          <HeaderLeft onPress={handleBackPress} />
          <IntercomButton />
        </Block>
      ) : (
        <HeaderContent
          navigationItems={navigationItems}
          handleBackPress={handleBackPress}
          setModalVisible={setModalVisible}
        />
      )}

      <CityPickerSheet isVisible={modalVisible} setModalVisible={setModalVisible} />

      <ShareCouponSheet toggle={() => setShareCouponVisible(false)} visible={shareCouponVisible} />
    </Block>
  );
};

export default React.memo(HomeHeader);

const styles = StyleSheet.create({
  container: {
    backgroundColor: palette.common.white,
    display: "flex",
    height: spacing.headerHeight,
    justifyContent: "center",
    position: "absolute",
    top: 0,
    width: "100%",
    zIndex: 2,
    alignSelf: "center",
    borderBottomColor: palette.common.lightGray,
    borderBottomWidth: 1,
  },
  content: {
    maxWidth: 1160,
    width: "100%",
    margin: "auto",
  },
});
